import axios from 'axios';
import api_url from '../urls';
const actions = {

    allTipoDocumento (context, valor) {

        const USER_TOKEN = localStorage.getItem('access_token');
        const AuthStr = 'Bearer '.concat(USER_TOKEN)
         axios.get( api_url.api_admin + 'v1/admin/tipo-documento',
         {
            headers: {
                'Authorization': AuthStr,
                'Content-Type': 'application/json',
                'X-Requested-With':'XMLHttpRequest',
            }
        })
        .then(response => {
            console.log(response.data)
            context.commit('ALL_TIPO_DOCUMENTO', response.data)
        })
        .catch((error) => {
            return error
        });
        
    },
    allProfissao (context, valor) {

        const USER_TOKEN = localStorage.getItem('access_token');
        const AuthStr = 'Bearer '.concat(USER_TOKEN)
         axios.get(api_url.api_admin + 'v1/admin/profissao',
         {
            headers: {
                'Authorization': AuthStr,
                'Content-Type': 'application/json',
                'X-Requested-With':'XMLHttpRequest',
            }
        })
        .then(response => {
            console.log(response.data)
            context.commit('ALL_PROFISSAO', response.data)
        })
        .catch((error) => {
            return error
        });
        
    },
    allEscolaridade (context, valor) {

        const USER_TOKEN = localStorage.getItem('access_token');
        const AuthStr = 'Bearer '.concat(USER_TOKEN)
         axios.get(`${api_url.api_admin}`+'v1/admin/escolaridade',
         {
            headers: {
                'Authorization': AuthStr,
                'Content-Type': 'application/json',
                'X-Requested-With':'XMLHttpRequest',
            }
        })
        .then(response => {
            console.log(response.data)
            context.commit('ALL_ESCOLARIDADE', response.data)
        })
        .catch((error) => {
            return error
        });

        
        
    },
    allSexo (context, valor) {

        const USER_TOKEN = localStorage.getItem('access_token');
        const AuthStr = 'Bearer '.concat(USER_TOKEN)
         axios.get(api_url.api_admin + 'v1/admin/sexo',
         {
            headers: {
                'Authorization': AuthStr,
                'Content-Type': 'application/json',
                'X-Requested-With':'XMLHttpRequest',
            }
        })
        .then(response => {
            console.log(response.data)
            context.commit('ALL_SEXO', response.data)
        })
        .catch((error) => {
            return error
        });
        
    },
    allEstadoCivil (context, valor) {

        const USER_TOKEN = localStorage.getItem('access_token');
        const AuthStr = 'Bearer '.concat(USER_TOKEN)
         axios.get(api_url.api_admin + 'v1/admin/estado-civil',
         {
            headers: {
                'Authorization': AuthStr,
                'Content-Type': 'application/json',
                'X-Requested-With':'XMLHttpRequest',
            }
        })
        .then(response => {
            console.log(response.data)
            context.commit('ALL_ESTADO_CIVIL', response.data)
        })
        .catch((error) => {
            return error
        });
        
    },
    allPais (context, valor) {

        const USER_TOKEN = localStorage.getItem('access_token');
        const AuthStr = 'Bearer '.concat(USER_TOKEN)
         axios.get(api_url.api_admin + 'v1/admin/pais',
         {
            headers: {
                'Authorization': AuthStr,
                'Content-Type': 'application/json',
                'X-Requested-With':'XMLHttpRequest',
            }
        })
        .then(response => {
            console.log(response.data)
            context.commit('ALL_PAIS', response.data)
        })
        .catch((error) => {
            return error
        });
        
    },
    GetEstadoNaturalidade (context, value) {
     //  console.log(value)
        const USER_TOKEN = localStorage.getItem('access_token');
        const AuthStr = 'Bearer '.concat(USER_TOKEN)
         axios.get(api_url.api_admin + 'v1/admin/estado-pais/'+ value,
         {
            headers: {
                'Authorization': AuthStr,
                'Content-Type': 'application/json',
                'X-Requested-With':'XMLHttpRequest',
            }
        })
        .then(response => {
           // console.log(response.data)
            context.commit('ALL_ESTADO_NATURALIDADE', response.data)
        })
        .catch((error) => {
            return error
        });
        
    },
    GetCidadeNaturalidade (context, value) {

        const USER_TOKEN = localStorage.getItem('access_token');
        const AuthStr = 'Bearer '.concat(USER_TOKEN)
         axios.get(api_url.api_admin + 'v1/admin/cidade-estado/'+ value,
         {
            headers: {
                'Authorization': AuthStr,
                'Content-Type': 'application/json',
                'X-Requested-With':'XMLHttpRequest',
            }
        })
        .then(response => {
            console.log(response.data)
            context.commit('ALL_CIDADE_NATURALIDADE', response.data)
        })
        .catch((error) => {
            return error
        });
        
    },
    GetEstadoEndereco (context, value) {
        //  console.log(value)
           const USER_TOKEN = localStorage.getItem('access_token');
           const AuthStr = 'Bearer '.concat(USER_TOKEN)
            axios.get(api_url.api_admin + 'v1/admin/estado-pais/'+ value,
            {
               headers: {
                   'Authorization': AuthStr,
                   'Content-Type': 'application/json',
                   'X-Requested-With':'XMLHttpRequest',
               }
           })
           .then(response => {
              // console.log(response.data)
               context.commit('ALL_ESTADO_ENDERECO', response.data)
           })
           .catch((error) => {
               return error
           });
           
    },
    GetCidadeEndereco (context, value) {

        const USER_TOKEN = localStorage.getItem('access_token');
        const AuthStr = 'Bearer '.concat(USER_TOKEN)
        axios.get(api_url.api_admin + 'v1/admin/cidade-estado/'+ value,
        {
            headers: {
                'Authorization': AuthStr,
                'Content-Type': 'application/json',
                'X-Requested-With':'XMLHttpRequest',
            }
        })
        .then(response => {
            console.log(response.data)
            context.commit('ALL_CIDADE_ENDERECO', response.data)
        })
        .catch((error) => {
            return error
        });
        
    },
  
}

export default actions